import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { get } from 'lodash'
import { connect } from 'react-redux'
import { apiConfiguration } from 'helpers/decorators/api'

@apiConfiguration()
@connect((state, props) => {
  const isConditionTrue = get(
    props,
    `configuration.values[${props.configKey}].${props.type}`,
    false
  )

  return { isConditionTrue }
})
class ConfigurationWrapper extends Component {
  static propTypes = {
    children: PropTypes.any,
    isConditionTrue: PropTypes.bool,
    onGetConfigurationValue: PropTypes.func,
    configKey: PropTypes.string,
    orgId: PropTypes.number
  }

  componentDidMount() {
    this.props.onGetConfigurationValue(this.props.configKey, this.props.orgId)
  }

  render() {
    if (!this.props.isConditionTrue) {
      return null
    }

    return <div>{this.props.children}</div>
  }
}

export default ConfigurationWrapper
